import axios from "axios";
import { scratchData } from "./data"; // Your game's data store
import { gameId, Token } from "../../../components/urlParams";

const RAW_URL = process.env.REACT_APP_USER_API_URL || "";
const BASE_URL = RAW_URL ? (RAW_URL.endsWith("/") ? RAW_URL : `${RAW_URL}/`) : "/api/v1/";

const getAuthToken = () => scratchData.jwtToken || Token || "";

const getHeaders = () => {
    const token = getAuthToken();
    return {
        Authorization: `AccessToken=${token}`,
        "Content-Type": "application/json"
    };
};

export const ApiService = {
    /**
     * Initializes the API service with the backend base URL.
     * @param {string} baseUrl The base URL for your game's backend API.
     */
    initializeApi: function(baseUrl) {
        // scratchData.baseUrl = baseUrl;
    },

    /**
     * Handles user login and retrieves the JWT token.
     * @param {object} credentials User login credentials (e.g., { username, password })
     * @returns {Promise<boolean>} True if login is successful, false otherwise.
     */
    loginUser: async function(credentials) {
        try {
            const response = await axios.post(`${BASE_URL}auth/login`, credentials, {
                headers: { "Content-Type": "application/json" }
            });
            scratchData.jwtToken = response.data.accessToken;
            scratchData.userId = response.data.user.id;
            scratchData.balance = response.data.wallet.balance;
            axios.defaults.headers.common['Authorization'] = `AccessToken=${scratchData.jwtToken}`;
            return true;
        } catch (error) {
            console.error("Login failed:", error);
            return false;
        }
    },

    /**
     * Makes an API call to get any pending bet for the user.
     * @returns {Promise<object>} The pending bet data, or an empty object if no pending bet.
     */
    getLastPendingBet: async function() {
        const currentGameId = scratchData.gameId || gameId;
        const token = getAuthToken();
        if (!token) {
            console.error("No JWT token available. User must log in.");
            throw new Error("No authorization token.");
        }

        try {
            const endpoint = `${BASE_URL}scratch-coin/get-pending-bet?gameId=${currentGameId}&currencyId=1`;
            const response = await axios.get(endpoint, {
                headers: getHeaders()
            });
            return response.data;
        } catch (error) {
            console.error("Get pending bet API failed:", error);
            throw error;
        }
    },

    /**
     * Makes an API call to buy tickets for the scratch game.
     * @param {object} ticketDetails Details for buying tickets (betAmount, gameId, currencyId).
     * @returns {Promise<object>} The response data from the buy tickets API.
     */
    buyTickets: async function(ticketDetails) {
        const token = getAuthToken();
        if (!token) {
            console.error("No JWT token available. User must log in.");
            throw new Error("No authorization token.");
        }

        const payload = {
            betAmount: ticketDetails.betAmount,
            gameId: scratchData.gameId || gameId,
            currencyId: ticketDetails.currencyId,
        };

        try {
            const response = await axios.post(`${BASE_URL}scratch-coin/buy-tickets`, payload, {
                headers: getHeaders()
            });
            return response.data;
        } catch (error) {
            console.error("Buy tickets API failed:", error);
            throw error;
        }
    },

    /**
     * Makes an API call to initiate the coin play game.
     * @param {object} gameDetails Details for starting the game (gameId, clientSeed, isCheatMode, cheatModeType, currencyId).
     * @returns {Promise<object>} The response data from the coin play game API.
     */
    coinPlayGame: async function(gameDetails) {
        const token = getAuthToken();
        if (!token) {
            console.error("No JWT token available. User must log in.");
            throw new Error("No authorization token.");
        }

        const payload = {
            gameId: scratchData.gameId || gameId,
            clientSeed: gameDetails.clientSeed,
            isCheatMode: gameDetails.isCheatMode,
            cheatModeType: gameDetails.cheatModeType,
            currencyId: gameDetails.currencyId,
        };

        try {
            const response = await axios.post(`${BASE_URL}scratch-coin/coin-play-game`, payload, {
                headers: getHeaders()
            });
            return response.data;
        } catch (error) {
            console.error("Coin Play Game API failed:", error);
            throw error;
        }
    },

    scratchScore: async function(index) {
        const token = getAuthToken();
        if (!token) {
            console.error("No JWT token available. User must log in.");
            throw new Error("No authorization token.");
        }

        const payload = {
            gameId: scratchData.gameId || gameId, 
            currencyId: 1,
            userId: scratchData.userId,
            scoreIndex: index,
        };

        try {
            const response = await axios.post(`${BASE_URL}scratch-coin/scratch-score`, payload, {
                headers: getHeaders()
            });
            return response.data;
        } catch (error) {
            console.error("Scratch Score API failed:", error);
            throw error;
        }
    },

    scratchCoinScore: async function(index) {
        const token = getAuthToken();
        if (!token) {
            console.error("No JWT token available. User must log in.");
            throw new Error("No authorization token.");
        }

        const payload = {
            gameId: scratchData.gameId || gameId, 
            currencyId: 1,
            userId: scratchData.userId,
            scoreIndex: index,
        };

        try {
            const response = await axios.post(`${BASE_URL}scratch-coin/scratch-coin-score`, payload, {
                headers: getHeaders()
            });
            return response.data;
        } catch (error) {
            console.error("Scratch coin Score API failed:", error);
            throw error;
        }
    },
};